import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyValidationMessage } from '@ngx-formly/core';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
}

@Component({
  selector: 'formly-wrapper-no-wrap',
  standalone: true,
  imports: [FormlyValidationMessage],
  template: `
    <div class="grid grid-cols-12 gap-2">
      <div class="col-span-12 md:col-span-10">
        <ng-container #fieldComponent></ng-container>
      </div>

      @if (showError) {
        <small class="p-error col-span-12">
          <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
        </small>
      }
    </div>
  `,
})
export class FormlyWrapperNon extends FieldWrapper<FormlyFieldConfig<FormlyFieldProps>> {
}
